 "use strict";
    /**
     * trsHight Module
     *
     * Description
     */

    angular.module('trsTreeScrollTopModule', []).directive('trsTreeScrollTop', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

        return {
            restrict: 'EA',
            link: function(scope, iElement, iAttrs) {
                $timeout(function(){
                    var flag = iElement.hasClass('tree-selected');
                   var aa = iElement.html();
                   if(flag){
                        var posT = iElement.position().top;
                        $(".treecontrol").animate({  
                            scrollTop:posT
                        }, 100); 
                   }
                },500);
            }
        };
    }]);